import * as turf from './turf';

export default {
    busapiURL: "busapi.php",
    busapiParams: (latitude, longitude, distance) => {
        return {
            latitude: latitude,
            longitude: longitude,
            distance: distance,
            username: 'bus_simulator'
        };
    },
    pointHasRelation: (point, data) => {
        const minX = parseFloat(data['mlongitude0'])
        if (isNaN(minX)) return false
        const minY = parseFloat(data['mlatitude1'])
        if (isNaN(minY)) return false
        const maxX = parseFloat(data['mlongitude1'])
        if (isNaN(maxX)) return false
        const maxY = parseFloat(data['mlatitude0'])
        if (isNaN(maxY)) return false
        const pt = turf.point([point.long, point.lat]);
        const poly = turf.polygon([[
            [minX, minY],
            [minX, maxY],
            [maxX, maxY],
            [maxX, minY],
            [minX, minY]
        ]]);
        return turf.booleanPointInPolygon(pt, poly)
    }
}
